import { render, staticRenderFns } from "./AutopsyInfo.vue?vue&type=template&id=789fab24&scoped=true"
import script from "./AutopsyInfo.vue?vue&type=script&lang=js"
export * from "./AutopsyInfo.vue?vue&type=script&lang=js"
import style0 from "./AutopsyInfo.vue?vue&type=style&index=0&id=789fab24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789fab24",
  null
  
)

export default component.exports